import { render } from "./Back.vue?vue&type=template&id=e7fc6dd2&bindings={\"go\":\"props\",\"label\":\"props\",\"audio\":\"data\",\"click\":\"options\"}"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"

import "./Back.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script